export const environment = {
  production: false,

  apiUrl: 'https://customers-test.kulladal.me/api/customers',
  millApiUrl: 'https://product-www-test.kulladal.me/api',

  // Cognito config,
  clientId: '78ao2k70ca9eapc89285951na8',
  userPoolId: 'eu-west-1_LrUY36OWg',
}
